/**
 * Event tracking stub. Google Analytics is disabled for ATC WORK.
 *
 * Exported as a singleton
 *
 * @class EventTracker
 */
class EventTracker {
    /**
     * @for EventTracker
     * @method recordEvent
     * @param category {TRACKABLE_EVENT}
     * @param action {string}
     * @param label {string}
     * @param value {string|null} [optional]
     */
    recordEvent() {}
}

export default new EventTracker();
